import React from "react";

export default ({ location }) => (
  <div>
    <h3 className="title is-3">
    Упс! Ничего по пути <code>{location.pathname}</code> нет :(
    </h3>
  </div>
);
